import React, { forwardRef } from "react";

export const ModalBox = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>((props, ref) => {
  const { children, className, ...rest } = props;
  return (
    <div
      ref={ref}
      className={`rounded bg-white min-h-10 w-fit min-w-[400px] max-h-[80vh] overflow-y-auto m-auto mt-[10vh] p-5 ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
});
